import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AuthService } from "../auth.service";
import { NavigationService } from "../../shared/services/navigation.service";

export const authGuard: CanActivateFn = (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.isAuthenticated()) return true;
    inject(NavigationService).rememberIntendedRoute(state.url, state.root);
    return router.createUrlTree(["/login"]);
};
